export default {
  pages: {
    key: "title",
    data: [
      {title: 'Misceláneos',   url: '/company',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Clientes',   url: '/clients',      icon: 'HomeIcon', is_bookmarked: false},
      {title: 'Productos', url: '/products', icon: 'FileIcon', is_bookmarked: false},
    ]
  }
}
